<script>
    import R, {LOADER} from "../lib/requests";
    import {OBJECTS, SERVICE_TYPE} from "../lib/constants";
    import user from "../stores/user";
    import app from "../stores/app";
    import charges from "../stores/charges";
    import PageHeader from "../components/PageHeader.svelte";
    import Icon from "../components/Icon.svelte";
    import AppIcon from "../components/icons/AppIcon.svelte";
    import TableHeader from "../components/TableHeader.svelte";
    import Alert from "../stores/alerts";
    import Notifier from "../stores/notifier";
    import ClientModal from "./ClientModal.svelte";
    import UserInitials from "../components/controls/UserInitials.svelte";
    import {sort} from "../lib/lib";

    const pageHeaderControls = [
        {key: 'create', name: 'ΔΗΜΙΟΥΡΓΙΑ'},
        {key: 'reload', name: '', icon: 'refresh'}
    ];

    const tableColumns = [
        {key: 'name', title: 'ΟΝΟΜΑ', sortable: true, sort_way: 'ASC'},
        {key: 'owner', title: '', sortable: false},
        {key: '', title: ''},
        {key: '', title: ''},
    ];

    let clients = null;
    let clientId = 0;
    let editId = null;
    let searchTerm = '';

    const load = () => {

        const onSuccess = result => {
            clients = result;
        }

        const onFailure = err => {
        };

        let search = {
            term: searchTerm,
        }
        R.handle(R.client.index, search, onSuccess, onFailure, LOADER.PAGE);
    };

    const onSearchKeyup = (event) => {
        if (event.key === 'Enter') {
            load();
        }
        if (event.key === 'Escape' && searchTerm) {
            searchTerm = "";
            load();
        }
    }


    const onCreate = () => {
        editId = 0;
    };

    const onEdit = (client) => {
        clientId = client.id;
        editId = client.id;
    };

    const closeEdit = param => {
        if (param) {
            if (editId == 0) {
                load();
            } else {
                let item = clients.find(x => x.id == param.id);
                if (item) {
                    item.name = param.name;
                    if (item.owner_id !== param.owner_id) {
                        item.owner_id = param.owner_id;
                        item.owner = app.getUser(param.owner_id);
                    }
                }
                clients = clients;
            }
        }
        editId = null;
    }


    const onColumnSort = ({detail: column}) => {
        clients = sort(clients, column.key, column.sort_way === 'ASC');
    };


    const onDelete = (client) => {
        const onSuccess = result => {
            let message = '';
            if (result.projects && result.projects > 0) {
                message = `Ο πελάτες είναι συνδεμένος με ${result.projects} ${result.projects > 1 ? 'projects' : 'project'}.\n`;
            }
            Alert.delete("Διαγραφή πελάτη", `${message}Να διαγραφτεί οριστικά ο πελάτης "${client.name}";`, () => deleteClient(client.id));
        }

        const onFailure = err => {
        };

        R.handle(R.client.relations, client.id, onSuccess, onFailure, LOADER.POPUP);
    }

    const deleteClient = (id) => {
        const onSuccess = result => {
            clients = clients.filter(x => x.id !== result);
            Notifier.showMessage("Ο πελάτης διαγράφτηκε");
        }

        const onFailure = err => {
        };

        R.handle(R.client.delete, id, onSuccess, onFailure, LOADER.POPUP);
    }

    const onCharge = item => {
        charges.create(OBJECTS.CLIENT, item.id, {client:item});
    }


    load();
</script>

<PageHeader title="Πελάτες" controls={ pageHeaderControls } on:create={ onCreate } on:reload={ load }/>

<div class="panel border-default mb-6">
    <div class="panel-body p-2">
        <div class="row">
            <div class="col-lg-3">
                <div class="input-group unbox-control">
                    <span class="input-group-text gray-icon"><Icon name="search"/></span>
                    <input type="text" class="form-control" bind:value="{ searchTerm }" on:keyup="{ onSearchKeyup }"
                           placeholder="όνομα ή email"/>
                </div>
            </div>
            <div class="col-lg-9 text-end">
                <button class="btn btn-primary" on:click="{ load }">ΕΥΡΕΣΗ</button>
            </div>
        </div>
    </div>
</div>
{#if clients}
    {#if clients.length}
        <table class="table table-list table-list-border">
            <TableHeader {tableColumns} on:sort={ onColumnSort }/>
            <tbody>
            {#each clients as client}
                <tr class="row-hover" class:row-selected="{ clientId === client.id }">
                    <td>
                        <button class="btn-reset is-link" on:click="{ () => onEdit(client) }">{ client.name }</button>
                    </td>
                    <td class="initials-column">
                        <UserInitials user={client.owner} md/>
                    </td>
                    <td class="button-column">
                        <button class="button" title="χρέωση" on:click={ () => onCharge(client) }>
                            <AppIcon icon="flash"/>
                        </button>
                    </td>
                    <td class="button-column">
                        <button class="button" title="διαγραφή" on:click="{ () => onDelete(client) }"
                                disabled={client.owner_id > 0 && client.owner_id !== $user.id}>
                            <AppIcon icon="trash"/>
                        </button>
                    </td>
                </tr>
            {/each}
            </tbody>
        </table>
    {:else}
        <div class="panel panel-default box-border">
            <div class="panel-body panel-pad">
                Δεν βρέθηκαν πελάτες
            </div>
        </div>
    {/if}
{/if}
{#if editId != null}
    <ClientModal clientId="{ editId }" closeCallback="{ closeEdit }"/>
{/if}

<style>
    .initials-column {
        width: 40px;
    }
</style>

